angular
  .module('admin')

  .factory('AccountManagerCache', function() {
    let cache;

    return {
      get: () => cache,
      set: value => (cache = value)
    };
  });
